import React from "react";
import { Globe, Facebook, Instagram, Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

// Footer component
function Footer() {
    return (
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8 pb-8 border-b border-gray-700">
            <div>
              <h3 className="text-lg font-bold mb-4 text-white uppercase tracking-wider">Enquiry</h3>
              <a href="mailto:contact@pie-es.com" className="flex items-center text-gray-400 hover:text-orange-500 transition-colors text-lg group">
                <Mail className="mr-3 text-gray-500 group-hover:text-orange-500 transition-colors" size={20} />
                contact@pie-es.com
              </a>
            </div>
            
            <div>
              <h3 className="text-lg font-bold mb-4 text-white uppercase tracking-wider">Connect With Us</h3>
              <div className="flex space-x-6">
                <a href="https://www.facebook.com/share/1LZmFGEkdf/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors" aria-label="Facebook">
                  <Facebook size={24} />
                </a>
                <a href="https://www.instagram.com/piees_world?igsh=MTAyOTQ1eGt5dnk4OA==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors" aria-label="Instagram">
                  <Instagram size={24} />
                </a>
                <a href="https://www.linkedin.com/in/piees-org-4683173a5?utm_source=share_via&utm_content=profile&utm_medium=member_android" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="LinkedIn">
                  <Linkedin size={24} />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 pt-6 text-center text-gray-400">
            <p>© 2025 PIEES. All rights reserved.</p>
            <div className="mt-2 flex justify-center space-x-6">
              <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white">Terms of Service</Link>
              <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }
  
  export {Footer};